import { z } from "zod";

export const machineOptionSchema = z.object({
  partNo: z.string().min(1, "Part No is required"),
  description: z.string().min(1, "Description is required"),
  category: z.string().min(1, "Category is required"),
  subCategory: z.string().optional(),
  price: z.coerce.number().nonnegative("Price must be a positive number"),
  availableOn: z.array(z.string().min(1)).min(1, "At least one machine is required"),
});

export type MachineOptionFormData = z.infer<typeof machineOptionSchema>;
